import React from 'react';
import { Select } from 'antd';
import { normalizeToSelect } from 'util/converters';
import roles from 'constants/roles';

const CollaboratorSelectRoles = ({
  onChange,
  hidePermissions = [],
  ...rest
}) => {
  if (!rest.value) {
    rest.value = [];
  }

  const handleTrigger = (value) => {
    onChange(
      roles
        .filter((c) => value.map((d) => d.value).includes(c.id))
        .map((c) => ({ role: c }))
    );
  };

  const handleFilter = (role) => {
    return !hidePermissions.includes(role.name);
  };

  const value = rest.value.map((c) => {
    return normalizeToSelect(
      roles.find((d) => d.id === c.role.id),
      { inputKey: 'id', inputLabel: 'description' }
    );
  });

  return (
    <Select {...rest} labelInValue value={value} onChange={handleTrigger}>
      {roles.filter(handleFilter).map((c) => (
        <Select.Option key={c.id} value={c.id}>
          {c.description}
        </Select.Option>
      ))}
    </Select>
  );
};

export default CollaboratorSelectRoles;
